import { useState } from "react";
import { cn } from "@/lib/class-control";

interface ExpandableTextProps {
  text: string;
  maxLength?: number;
  className?: string;
}

export function ExpandableText({
  text,
  maxLength = 300,
  className
}: ExpandableTextProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  const shouldTruncate = text.length > maxLength;
  const displayText = isExpanded || !shouldTruncate
    ? text
    : `${text.slice(0, maxLength)}...`;

  if (!shouldTruncate) {
    return (
      <p className={cn(
        "font-['Plus_Jakarta_Sans'] font-normal leading-[1.4] text-[#d1d1d1] text-[14px]",
        className
      )}>
        {text}
      </p>
    );
  }

  return (
    <div className={className}>
      <p className="font-['Plus_Jakarta_Sans'] font-normal leading-[1.4] text-[#d1d1d1] text-[14px] whitespace-pre-line">
        {displayText}
      </p>
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="mt-1 font-['Plus_Jakarta_Sans'] font-semibold text-[14px] text-[#13d480] underline hover:text-[#0b8a53] transition-colors"
      >
        {isExpanded ? "Ler menos" : "Ler mais"}
      </button>
    </div>
  );
}
